import React from 'react';
import { Header, Footer } from '../components/common';
import '../components/common/PageLayout.css';

const PrivacyPolicy = () => {
  return (
    <>
      <div className="hero-gradient-wrap">
        <Header ctaText="Join Community" ctaPath="#courses" />
        <section className="page-hero">
          <h1>Privacy Policy</h1>
          <p>
            At InfinySkills, we strongly respect your privacy and strive to provide a safe and secure
            user experience.
          </p>
        </section>
      </div>
      <main className="page-layout-main">
        <section className="page-section">
          <h2>Overview</h2>
          <p>
            This Privacy Policy outlines our data collection, usage policies, and practices. By using our
            website and services, you consent to the policies and practices described in this statement.
          </p>
          <p>
            Your data may be stored and processed within or outside India, and your use of the website
            constitutes consent to the transfer of your data outside India when necessary.
          </p>
          <p>
            Our website may contain links to external websites over which we have no control. We are not
            responsible for the privacy policies or practices of those websites. We encourage you to
            review their privacy policies to understand how they collect, use, and share your information.
          </p>
          <p>
            This Privacy Policy applies solely to the information collected through InfinySkills and does
            not apply to information collected through other channels.
          </p>
        </section>

        <section className="page-section">
          <h2>Collection and Retention of Information</h2>
          <p>
            In certain areas of our website, we may request personal information including your name,
            address, email address, phone number, contact details, billing information, or any other
            information that may identify you.
          </p>
          <p>
            We may also collect demographic information that is not unique to you, such as ZIP code, age,
            preferences, and gender. This may occur when you register for a course, subscribe to our
            services, participate in surveys, or engage with learning programs.
          </p>
          <p>
            Additionally, we may indirectly collect information when you interact with third-party
            services integrated into our website. Such information will be handled in accordance with this
            Privacy Policy.
          </p>
          <p>
            We may also collect information regarding your interaction with our website, including pages
            visited, features accessed, course engagement activity, device and browser information, IP
            address, domain names, access times, and referring website addresses. This information helps
            us improve our services and enhance user experience.
          </p>
          <p>
            In some cases, you may voluntarily provide additional information such as preferences,
            interests, learning goals, or lifestyle information. Providing such information is entirely
            optional. If you choose to provide it, you consent to its use as described in this policy,
            including receiving communications about courses, programs, or opportunities relevant to you.
          </p>
          <p>
            Please note that if you post personal information in public areas of our website, such as
            forums or community discussions, that information may be collected and used by others.
            InfinySkills is not responsible for how third parties use such publicly shared information.
          </p>
          <p>
            To improve your long-term learning experience, we may retain information associated with your
            account so that your future interactions with our platform remain efficient and personalised.
            However, you may update or correct your account information at any time. You may also request
            deletion of your account, in which case we will remove your accessible profile information
            except for limited archival records maintained for compliance purposes.
          </p>
        </section>

        <section className="page-section">
          <h2>Children</h2>
          <p>InfinySkills services are not intended for children under the age of 13.</p>
          <p>We do not knowingly collect personal information from children under 13 years of age.</p>
        </section>

        <section className="page-section">
          <h2>Cookies</h2>
          <p>
            Like many websites, InfinySkills uses cookies to enhance your browsing experience and retain
            certain preferences or settings. Cookies may help us understand website usage, improve
            platform performance, and personalise user experiences.
          </p>
          <p>
            Some third-party services or advertisements on our website may also use cookies. These third
            parties operate under their own privacy policies and do not have access to our internal
            cookies.
          </p>
        </section>

        <section className="page-section">
          <h2>Third-Party Integrations</h2>
          <p>
            InfinySkills may integrate with third-party platforms or services to improve user experience.
            When you sign in using external services or connect accounts, limited information may be used
            to create or enhance your profile on the platform. All such data usage will follow the
            guidelines outlined in this Privacy Policy.
          </p>
        </section>

        <section className="page-section">
          <h2>Changes to this Privacy Policy</h2>
          <p>
            We may update this Privacy Policy periodically. When significant changes occur, we will notify
            users by either posting an announcement on our website or sending a notification to the email
            address associated with your account.
          </p>
          <p>
            We encourage users to review this page regularly to stay informed about how we protect their
            information.
          </p>
        </section>

        <section className="page-section">
          <h2>No Guarantees</h2>
          <p>
            While we take reasonable steps to protect user data and maintain high security standards, we
            cannot guarantee absolute protection against all risks. Certain factors beyond our control may
            result in data disclosure. Accordingly, InfinySkills disclaims any warranties regarding the
            maintenance or nondisclosure of user data.
          </p>
        </section>

        <section className="page-section">
          <h2>Contact Information</h2>
          <p>If you have any questions regarding this Privacy Policy or our website, please contact us at:</p>
          <p>
            Email: <a href="mailto:khyati@infinyskills.com">khyati@infinyskills.com</a>
          </p>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;

